// extracted by mini-css-extract-plugin
export default {"page":"RQ-z","cartModal":"SQ-z","checkout":"TQ-z","placeholder":"UQ-z","account":"VQ-z"};